import {
  REQUEST_FARM_FEATURES_PAGE_INFORMATION,
  SAVE_CHANGES_TO_FARM_FEATURES_INFORMATION_PAGE,
} from './types.js';
import {
  getFarmFeaturesInformationSuccess,
  getFarmFeaturesIformationError,
  saveChangesToFarmFeaturesPageSuccess,
  saveChangesToFarmFeaturesPageSuccessError,
} from './actions.js';
import { put, take, call } from 'redux-saga/effects';
import {
  startLoading,
  endLoading,
} from '../../../common/redux/loadManager/actions';
import { getLoadId } from '../../../common/redux/loadManager/methods';

let currentLoadId = 0;

export function* initalizeFarmFeaturesPageSaga(api) {
  while (true) {
    const farmFeaturesInformationRequestAction = yield take(
      REQUEST_FARM_FEATURES_PAGE_INFORMATION,
    );
    /** Run loader */
    currentLoadId = getLoadId();
    yield put(startLoading(currentLoadId));
    const { accessToken } = farmFeaturesInformationRequestAction.payload;
    yield call(getFarmFeaturesDetails, api, accessToken);
  }
}

/** Create request to get about the farm page latest state of data from the backend
 * @param {string} accessToken - User access token
 */
function* getFarmFeaturesDetails(api, accessToken) {
  try {
    const farmFeaturesPageDetails = yield call(
      api.getFarmFeaturesDetails,
      accessToken,
    );
    yield put(getFarmFeaturesInformationSuccess(farmFeaturesPageDetails.data));
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  } catch (error) {
    /** Error code parsed to string   */
    const errorCode = error && error.toString().substr(-3);
    yield put(getFarmFeaturesIformationError(error));
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  }
}

export function* farmFeaturesSaveChangesSaga(api) {
  while (true) {
    const saveChangesRequestAction = yield take(
      SAVE_CHANGES_TO_FARM_FEATURES_INFORMATION_PAGE,
    );
    /** Run loader */
    currentLoadId = getLoadId();
    yield put(startLoading(currentLoadId));
    const { accessToken, newFarmFeaturesDetails } =
      saveChangesRequestAction.payload;
    yield call(
      saveChangesFarmFeaturesPage,
      api,
      accessToken,
      newFarmFeaturesDetails,
    );
  }
}

/** Create request to get about the farm page latest state of data from the backend
 * @param {string} accessToken - User access token
 * @param {Object} newFarmFeaturesDetails - The latest state of the farm details data coming directly from the frontend which we want to persist on the backend
 */
function* saveChangesFarmFeaturesPage(
  api,
  accessToken,
  newFarmFeaturesDetails,
) {
  try {
    const updateFarmFeaturesDataResponse = yield call(
      api.setFarmFeaturesTextBlocks,
      accessToken,
      newFarmFeaturesDetails,
    );
    yield put(
      saveChangesToFarmFeaturesPageSuccess(updateFarmFeaturesDataResponse.data),
    );
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  } catch (error) {
    /** Error code parsed to string   */
    const errorCode = error && error.toString().substr(-3);
    yield put(saveChangesToFarmFeaturesPageSuccessError(error));
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  }
}
